import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { CreateClientIdentityApiMutationRequest, CreateClientIdentityApiMutationResponse, CreateClientIdentityApiPathParams, CreateClientIdentityApi400 } from "../types/CreateClientIdentityApi";
import type { UseMutationOptions } from "@tanstack/react-query";

 type CreateClientIdentityApiClient = typeof client<CreateClientIdentityApiMutationResponse, CreateClientIdentityApi400, CreateClientIdentityApiMutationRequest>;
type CreateClientIdentityApi = {
    data: CreateClientIdentityApiMutationResponse;
    error: CreateClientIdentityApi400;
    request: CreateClientIdentityApiMutationRequest;
    pathParams: CreateClientIdentityApiPathParams;
    queryParams: never;
    headerParams: never;
    response: CreateClientIdentityApiMutationResponse;
    client: {
        parameters: Partial<Parameters<CreateClientIdentityApiClient>[0]>;
        return: Awaited<ReturnType<CreateClientIdentityApiClient>>;
    };
};
/**
 * @summary Create API Key
 * @link /api/clients/:clientCode/identities/apikeys
 */
export function useCreateClientIdentityApi(clientCode: CreateClientIdentityApiPathParams["clientCode"], options: {
    mutation?: UseMutationOptions<CreateClientIdentityApi["response"], CreateClientIdentityApi["error"], CreateClientIdentityApi["request"]>;
    client?: CreateClientIdentityApi["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async (data) => {
            const res = await client<CreateClientIdentityApi["data"], CreateClientIdentityApi["error"], CreateClientIdentityApi["request"]>({
                method: "post",
                url: `/api/clients/${clientCode}/identities/apikeys`,
                data,
                headers: { "Content-Type": "text/json", ...clientOptions.headers },
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}